var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFordassist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ford assist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BlueCruise/Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.-Account",
    transform: "translate(-122.000000, -1387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Building-Blocks-/-16x16",
    transform: "translate(124.000000, 1390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24924653,-2.8015048 L8.31677667,-2.72304449 L8.42917994,-2.58443759 C8.53986514,-2.45352306 8.66909173,-2.31255976 8.81381592,-2.16587587 C9.2705108,-1.70299706 9.8000987,-1.26335906 10.3906199,-0.864550462 C12.2325634,0.37940655 14.3590814,1.03686889 16.7367126,1.03686889 C17.1140589,1.03686889 17.4199347,1.34282804 17.4199347,1.72021838 C17.4199347,9.81198804 14.8151478,14.6662901 8.13275074,18.8941566 C7.90968844,19.0352853 7.62530182,19.0352808 7.40224387,18.8941452 C0.720450818,14.6663684 -1.88398693,9.81219533 -1.88398693,1.72021838 C-1.88398693,1.34305839 -1.57847051,1.03719477 -1.2013547,1.03686914 C1.16461194,1.03482624 3.28755577,0.377272216 5.13320604,-0.865125914 C5.72606174,-1.26420632 6.2585427,-1.70417414 6.71854717,-2.16743039 C6.79697067,-2.24640826 6.87094601,-2.32377191 6.93933345,-2.39809464 L7.03758123,-2.50711969 L7.1693535,-2.66170077 L7.22009764,-2.72554955 C7.47303904,-3.06429814 7.96140621,-3.0892845 8.24924653,-2.8015048 Z M7.76581699,-1.2838562 L7.68807633,-1.20434754 C7.1652274,-0.677802572 6.56404084,-0.180888371 5.89615464,0.268698735 C4.07983918,1.49135019 2.01843023,2.21129474 -0.249531078,2.37014629 L-0.510784317,2.38424837 L-0.507844582,2.55007679 C-0.347828479,9.26010959 1.80940833,13.4100444 7.11852949,17.0698478 L7.44752575,17.2933225 L7.7672549,17.5038562 L8.08790106,17.2930555 C13.4636122,13.6940536 15.7337403,9.6588132 16.0216494,3.20082144 L16.0370728,2.79402437 L16.046732,2.38568628 L15.8716674,2.37687854 C13.8941773,2.25373594 12.0735535,1.70630853 10.4357299,0.771731477 L10.0875751,0.565552738 L9.81670606,0.394461808 L9.62595696,0.268118353 C9.09306826,-0.0917681726 8.60328606,-0.481981011 8.16250956,-0.893454116 L7.84120794,-1.20590359 L7.76581699,-1.2838562 Z M12.8360513,4.01602925 L13.8392492,4.99081024 L6.71916624,11.9983209 L2.9543277,8.29113854 L3.95807596,7.30441866 L6.7190196,10.0231373 L12.8360513,4.01602925 Z",
    id: "GuardMode"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Keyboard-Focus",
    x: -12,
    y: -12,
    width: 40,
    height: 40
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFordassist);
export default __webpack_public_path__ + "static/media/Ford assist.2eb01d46a5a726d38918cba6ab6c5775.svg";
export { ForwardRef as ReactComponent };